import React from "react";
import ScreeningQuestionThree from "../shared/ScreeningQuestionThree";
import { handleStoreScreeningScheduledDetails } from "../public/CommonAPIHelper";

const ScreeningScheduledQuestionThreeUI = () => {
  return (
    <ScreeningQuestionThree
      questionText="Where is your screening scheduled?"
      textFieldLabel="Screening Location"
      backRoute="./2"
      submitRoute="/screeningscheduled/thankyouresponse"
      onSubmitHandler={handleStoreScreeningScheduledDetails}
    />
  );
};

export default ScreeningScheduledQuestionThreeUI;
